'use strict';

import React from 'react';
import classNames from 'classnames';

class CheckBox extends React.Component {

    constructor(props) {
        super(props);
    }

    changeValue = () => {
        if (this.props.onChange) {           
            this.props.onChange();
        }
    }

    render() {

        const classes = classNames(
            'fc-checkbox', this.props.className, {
                disabled: this.props.disabled,
                indent: this.props.indent,
            }
        );

        return (
            <div id={'form-element-{0}'.format(this.props.name)} className={classes}>
                <input 
                    formNoValidate
                    name={this.props.name}
                    id={this.props.name}
                    type="checkbox"
                    onChange={this.changeValue}
                    disabled={this.props.disabled}
                    checked={this.props.checked}
                />
                <label htmlFor={this.props.name}>{this.props.label}</label>

                {this.props.childComponent ? (
                    <div className="fc-checkbox-child">
                        {React.cloneElement(
                            this.props.childComponent
                        )}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default CheckBox; 
